import { NODE_ENV_ZOD } from "@voicely/zod-schemas/node_env";
import { object, preprocess, string, url } from "zod";

// Empty string is a valid production value — it signals "same-origin": nginx
// forwards /api/* to the backend on this hostname, so the client builds
// relative URLs against window.location.origin. Same contract as
// apps/frontend.
const apiUrlOrEmpty = preprocess(
	(val) => (val === "" ? undefined : val),
	url("API URL must be a valid URL").optional(),
);

export const envSchemaZod = object({
	VITE_USER_NODE_ENV: NODE_ENV_ZOD,
	VITE_API_URL: apiUrlOrEmpty,
	VITE_DEV_BACKEND_PROXY_TARGET: preprocess(
		(val) => (val === "" ? undefined : val),
		string().optional(),
	),
});
